import React from 'react';
import "./footer.css";
import {  FiGithub, FiLinkedin } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer id="footer" className="footer">
        <div className="footer__container container">
            <h3 className="footer__title">Samar</h3>
            <ul className="footer__list">
                <li>
                    <a href="#about" className="footer__link">About</a>
                </li>
                <li>
                    <a href="#portfolio" className="footer__link">Projects</a>
                </li>
              
            </ul>
            <div className="footer__social">
              
                <a href="https://github.com/slamasamar4" className="home__social-icon" target="_blank" rel="noreferrer">
                    <FiGithub />
                </a>
                <a href="https://www.linkedin.com/in/samar-slama430/" className="home__social-icon" target="_blank" rel="noreferrer" >
                    <FiLinkedin />
                </a>    
            </div>
            <span className="footer__copy"></span>
        </div>
    </footer>
  );
}

export default Footer;